unit UTransferModel;

interface

uses
  UEssentialHelper, JS, UAttachmentModel, UResultModel, UWebReportUtils;

type
  TTransferModel = class
  private
    FFilename: string;
    FPersonalNr: string;
    FFakNr: string;
    FKind: TAttachmentKind;
    FData: string;
    FTermBuId: Integer;
    FOnTransmitted: TCallback;
    FOnError: TErrorEvent;
    FResult: TResultModel;
    FId: Integer;
    FReceived: TDateTime;
    FOnGetData: TCallback;
    FName: string;
    FCreated: TDateTime;
    FVorname: string;
    FDatum: TDateTime;
    procedure ClearValues;
    procedure DoGetData;
    procedure DoHandleError(AMsg: string);
    procedure DoTransmitted;
    procedure SetValues(Json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetData(const Value: string);
    procedure SetFakNr(const Value: string);
    procedure SetFilename(const Value: string);
    procedure SetKind(const Value: TAttachmentKind);
    procedure SetPersonalNr(const Value: string);
    procedure SetTermBuId(const Value: Integer);
    procedure SetOnError(const Value: TErrorEvent);
    procedure SetOnTransmitted(const Value: TCallback);
    procedure SetResult(const Value: TResultModel);
    procedure SetId(const Value: Integer);
    procedure SetReceived(const Value: TDateTime);
    procedure SetOnGetData(const Value: TCallback);
    procedure SetCreated(const Value: TDateTime);
    procedure SetName(const Value: string);
    procedure SetVorname(const Value: string);
    procedure SetDatum(const Value: TDateTime);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    constructor Create(Model: TAttachmentModel; TermBuId: Integer); overload;
    constructor Create(Model: TReport; TermBuId: Integer); overload;
    function ToJson(WithData: Boolean): string;
    procedure GetData(url: string);
    procedure Transmit(url: string);
    property FakNr: string read FFakNr write SetFakNr;
    property PersonalNr: string read FPersonalNr write SetPersonalNr;
    property Filename: string read FFilename write SetFilename;
    property Kind: TAttachmentKind read FKind write SetKind;
    property Data: string read FData write SetData;
    property TermBuId: Integer read FTermBuId write SetTermBuId;
    property OnTransmitted: TCallback read FOnTransmitted
      write SetOnTransmitted;
    property OnError: TErrorEvent read FOnError write SetOnError;
    property Result: TResultModel read FResult write SetResult;
    property Id: Integer read FId write SetId;
    property Received: TDateTime read FReceived write SetReceived;
    property OnGetData: TCallback read FOnGetData write SetOnGetData;
    property Name: string read FName write SetName;
    property Vorname: string read FVorname write SetVorname;
    property Created: TDateTime read FCreated write SetCreated;
    property Datum: TDateTime read FDatum write SetDatum;
  end;

implementation

uses
  WebLib.Json, System.SysUtils, WebLib.REST, WebLib.Controls, WebLib.LocalFiles;

{ TtransferModel }

procedure TTransferModel.ClearValues;
begin
  Self.FakNr := '';
  Self.PersonalNr := '';
  Self.Filename := '';
  Self.Kind := akUnknown;
  Self.Data := '';
  Self.TermBuId := 0;
  Self.Result := nil;
  Self.Id := 0;
  Self.Received := 0;
  Self.Name := '';
  Self.Vorname := '';
  Self.Created := 0;
  Self.Datum := 0;
end;

constructor TTransferModel.Create;
begin
  Self.ClearValues;
  Self.OnTransmitted := nil;
  Self.OnError := nil;
  Self.OnGetData := nil;
end;

constructor TTransferModel.Create(Json: string);
begin
  Self.SetValues(Json);
  Self.OnTransmitted := nil;
  Self.OnError := nil;
  Self.OnGetData := nil;
end;

procedure TTransferModel.SetCreated(const Value: TDateTime);
begin
  FCreated := Value;
end;

procedure TTransferModel.SetData(const Value: string);
begin
  FData := Value;
end;

procedure TTransferModel.SetDatum(const Value: TDateTime);
begin
  FDatum := Value;
end;

procedure TTransferModel.SetFakNr(const Value: string);
begin
  FFakNr := Value;
end;

procedure TTransferModel.SetFilename(const Value: string);
begin
  FFilename := Value;
end;

procedure TTransferModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TTransferModel.SetKind(const Value: TAttachmentKind);
begin
  FKind := Value;
end;

procedure TTransferModel.SetName(const Value: string);
begin
  FName := Value;
end;

procedure TTransferModel.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TTransferModel.SetOnGetData(const Value: TCallback);
begin
  FOnGetData := Value;
end;

procedure TTransferModel.SetOnTransmitted(const Value: TCallback);
begin
  FOnTransmitted := Value;
end;

procedure TTransferModel.SetPersonalNr(const Value: string);
begin
  FPersonalNr := Value;
end;

procedure TTransferModel.SetReceived(const Value: TDateTime);
begin
  FReceived := Value;
end;

procedure TTransferModel.SetResult(const Value: TResultModel);
begin
  FResult := Value;
end;

procedure TTransferModel.SetTermBuId(const Value: Integer);
begin
  FTermBuId := Value;
end;

procedure TTransferModel.SetValues(obj: TJsObject);
var
  s: string;
begin
  Self.ClearValues;
  if obj['FakNr'] <> nil then
    Self.FakNr := string(obj['FakNr']);
  if obj['PersonalNr'] <> nil then
    Self.PersonalNr := string(obj['PersonalNr']);
  if obj['Filename'] <> nil then
    Self.Filename := string(obj['Filename']);
  if obj['Kind'] <> nil then
    Self.Kind := StrToAttachmentKind(string(obj['Kind']));
  if obj['TermBuId'] <> nil then
    Self.TermBuId := StrToInt(string(obj['TermBuId']));
  if obj['Data'] <> nil then
    Self.Data := string(obj['Data']);
  if obj['Result'] <> nil then
  begin
    s := string(obj['Result']);
    Self.Result := TResultModel.Create(s);
  end;
  if obj['Id'] <> nil then
    Self.Id := StrToInt(string(obj['Id']));
  if obj['Received'] <> nil then
    Self.Received := StrToDateTime(string(obj['Received']));
  if obj['Name'] <> nil then
    Self.Name := string(obj['Name']);
  if obj['Vorname'] <> nil then
    Self.Vorname := string(obj['Vorname']);
  if obj['Created'] <> nil then
    Self.Created := StrToDateTime(string(obj['Created']));
  if obj['Datum'] <> nil then
    Self.Datum := StrToDateTime(string(obj['Datum']));
end;

procedure TTransferModel.SetVorname(const Value: string);
begin
  FVorname := Value;
end;

procedure TTransferModel.SetValues(Json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(Json);
  Self.SetValues(obj);
end;

function TTransferModel.ToJson(WithData: Boolean): string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('FakNr', Self.FakNr);
  obj.AddPair('PersonalNr', Self.PersonalNr);
  obj.AddPair('Filename', Self.Filename);
  obj.AddPair('Kind', AttachmentKindToStr(Self.Kind));
  obj.AddPair('TermBuId', IntToStr(Self.TermBuId));
  if WithData then
    obj.AddPair('Data', Self.Data);
  obj.AddPair('Id', IntToStr(Self.Id));
  obj.AddPair('Received', DateTimeToStr(Self.Received));
  obj.AddPair('Name', Self.Name);
  obj.AddPair('Vorname', Self.Vorname);
  obj.AddPair('Created', DateTimeToStr(Self.Created));
  obj.AddPair('Datum', DateTimeToStr(Self.Datum));
  Result := obj.ToJson;
  obj.Free;
end;

procedure TTransferModel.Transmit(url: string);
var
  s: string;
  obj: TJsonObject;
  client: TRestClient;
  procedure HandleError(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Self.DoHandleError('Übertragung fehlgeschlagen!');
  end;

  procedure Response(Sender: TObject; AResponse: string);
  var
    Result: TResultModel;
  begin
    if AResponse <> '' then
    begin
      Result := TResultModel.Create(AResponse);
      if Result.ResultValue then
        Self.DoTransmitted
      else
        Self.DoHandleError(Result.ResultMessage);
    end;
  end;

begin
  s := Self.ToJson(true);
  obj := TJsonObject.Create;
  obj.AddPair('value', s);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := HandleError;
  client.HttpsPost(url + '/AttachmentService/Insert', 'application/json',
    obj.ToString);
  obj.Free;
end;

constructor TTransferModel.Create(Model: TAttachmentModel; TermBuId: Integer);
begin
  Self.ClearValues;
  Self.FakNr := Model.FakNr;
  Self.PersonalNr := Model.PersonalNr;
  Self.Filename := Model.Filename;
  Self.Kind := Model.Kind;
  Self.TermBuId := TermBuId;
  Self.Name := Model.Name;
  Self.Vorname := Model.Vorname;
  Self.Created := Model.CreatedAt;
end;

procedure TTransferModel.DoGetData;
begin
  if Assigned(Self.OnGetData) then
    Self.OnGetData(Self);
end;

procedure TTransferModel.DoHandleError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TTransferModel.DoTransmitted;
begin
  if Assigned(Self.OnTransmitted) then
    Self.OnTransmitted(Self);
end;

procedure TTransferModel.GetData(url: string);
var
  client: TRestClient;
  obj: TJsonObject;
  procedure Response(Sender: TObject; AResponse: string);
  var
    s: string;
    t: TTextFile;
    jo: TJsObject;

    procedure HandleFileSave(Sender: TObject);
    begin
      Self.DoGetData;
    end;

  begin
    if AResponse <> '' then
    begin
      jo := TJsJson.parseObject(AResponse);
      if jo['value'] <> nil then
        s := string(jo['value']);
      if Pos('FakNr', s) > 0 then
        Self.SetValues(s)
      else
        Self.Result := TResultModel.Create(s);
      if Self.Result.ResultValue then
      begin
        case Self.Kind of
          akUnknown:
            ;
          akPicture:
            begin
              s := HexToBase64(Self.Data);
              s := 'data:image/png;base64,' + s;
              t := TTextFile.Create(nil);
              t.OnFileSave := HandleFileSave;
              t.Text := s;
              t.SaveAsFile(Self.FFakNr + '\Pictures', Self.Filename);
            end;
          akComment:
            begin
              t := TTextFile.Create(nil);
              t.OnFileSave := HandleFileSave;
              t.Text := Self.Data;
              t.SaveAsFile(Self.FFakNr + '\Comments', Self.Filename);
            end;
          akPdf:
            begin
              s := HexToBase64(Self.Data);
              t := TTextFile.Create(nil);
              t.OnFileSave := HandleFileSave;
              t.Text := s;
              t.SaveAsFile(Self.FFakNr + '\Pdfs', Self.Filename);
            end;
        end;
      end
      else
        Self.DoHandleError(Self.Result.ResultMessage);
    end
    else
      Self.DoHandleError('Verbindungfehler: TAttachmentModel.GetData!');
  end;

  procedure ErrorHandling(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('value', Self.ToJson(false));
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandling;
  client.HttpsPost(url + '/AttachmentService/GetData', 'application/json',
    obj.ToJson);
end;

constructor TTransferModel.Create(Model: TReport; TermBuId: Integer);
begin
  Self.ClearValues;
  Self.FakNr := Model.Fak.Nr;
  Self.PersonalNr := Model.User.PersonalNr;
  Self.Filename := Model.PdfFilename;
  Self.Kind := akPdf;
  Self.TermBuId := TermBuId;
  Self.Name := Model.User.Name;
  Self.Vorname := Model.User.Vorname;
  Self.Created := Model.CreatedAt;
  Self.Datum := Model.Datum;
end;

end.
